module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Snow-9a86319a5a78e4c6f666047694c38641.svg";